import './index.sass'
import axios from 'axios'

import Turbolinks from 'turbolinks';

const signIn = () => {

    $('.signin-reg form').on('submit', function (e) {
        e.preventDefault()
        let one = e.currentTarget[8].checked;
        let two = e.currentTarget[10].checked;

        axios.post('/sign_up', $(this).serialize())
            .then(response => {
                handleSuccessSignUp(one, two);
                Turbolinks.visit('/');
            })
            .catch(err => {
                Turbolinks.visit('/sign_up');
            })
    });

};

signIn();

document.addEventListener('turbolinks:load', signIn);